import baseSearch from './_base'

export default baseSearch({
  state: {
    filterset_name: 'basic_filter',
    _type: 'stock_item',
  },
})


// WEBPACK FOOTER //
// ./ixcms/themes/src/vue-src/store/modules/search/items.js